import request from '@/utils/request.js'

// 查询审核机构列表
export function AuditList() {
    return request({
        url:'/merchant/auditList',
        method:'get',
    })
}

// 查询平台审核列表
export function list(params) {
    return request({
        url:'/batch/routeList',
        method:'post',
        data:params
    })
}

// 审核
export function batching(batchId,auditMerchant) {
    return request({
        url:'/trace/update',
        method:'post',
        params:{
            state:6,
            batchId,
            auditMerchant
        }
    })
}

// 检测是否通过
export function isPass(state,batchId,reason) {
    return request({
        url:'/trace/update',
        method:'post',
        params:{
            state,
            batchId,
            reason
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/platform.js